const types = {
  GET_FORM_SUBMISSIONS_START: 'GET_FORM_SUBMISSIONS_START',
  GET_FORM_SUBMISSIONS_SUCCESS: 'GET_FORM_SUBMISSIONS_SUCCESS',
  GET_FORM_SUBMISSIONS_FAILURE: 'GET_FORM_SUBMISSIONS_FAILURE',
  MARK_AS_READ_SUCCESS: 'MARK_AS_READ_SUCCESS',
  MARK_ALL_READ_SUCCESS: 'MARK_ALL_READ_SUCCESS',
  GET_UNREAD_COUNT_SUCCESS: 'GET_UNREAD_COUNT_SUCCESS',
};

export default types;
